// copied from auth0-js/src/helper/random.js
const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
function randomString(length) {
    const bytes = new Uint8Array(length);
    const result = [];
    const cryptoObj = // eslint-disable-next-line @typescript-eslint/dot-notation
    'msCrypto' in window ? window['msCrypto'] : window.crypto;
    if (!cryptoObj) {
        return null;
    }
    const random = cryptoObj.getRandomValues(bytes);
    for(let a = 0; a < random.length; a++){
        result.push(charset[random[a] % charset.length]);
    }
    return result.join('');
}

export { randomString };
//# sourceMappingURL=random-string.js.map
